import { render, staticRenderFns } from "./customStatusModal.vue?vue&type=template&id=6220c54c&scoped=true"
import script from "./customStatusModal.vue?vue&type=script&lang=js"
export * from "./customStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6220c54c",
  null
  
)

export default component.exports